const SIMILARITY_PERCENT_MULTIPLIER = 100;

export const MIN_SIMILARITY_PERCENT = 0;
export const MAX_SIMILARITY_PERCENT = 100;

interface SimilarityFilters {
  top_similar_object_similarity__gte: number | undefined;
  top_similar_object_similarity__lt: number | undefined;
}

export function getSimilarityPercent(value: number | undefined, fallback: number): number {
  if (value === undefined) return fallback;
  return Math.round(value * SIMILARITY_PERCENT_MULTIPLIER);
}

export function getSimilarityFilterValue(value: number): number {
  return value / SIMILARITY_PERCENT_MULTIPLIER;
}

export function getSimilarityLabel(gte: number | undefined, lt: number | undefined): string {
  return `${
    getSimilarityPercent(gte, MIN_SIMILARITY_PERCENT)
  }–${
    getSimilarityPercent(lt, MAX_SIMILARITY_PERCENT)
  } %`;
}

export function getSimilarityFilters(gte: number, lt: number): SimilarityFilters {
  const filters: SimilarityFilters = {
    top_similar_object_similarity__gte: undefined,
    top_similar_object_similarity__lt: undefined,
  };

  if (gte > MIN_SIMILARITY_PERCENT) {
    filters.top_similar_object_similarity__gte = getSimilarityFilterValue(gte);
  }

  if (lt < MAX_SIMILARITY_PERCENT) {
    filters.top_similar_object_similarity__lt = getSimilarityFilterValue(lt);
  }

  return filters;
}
